import { ErrorElement } from 'App';
import { Route, Routes } from 'react-router-dom';
import {
  AddActionPage,
  AddTarget,
  EsrsAssessment,
  EsrsAssessmentConfig,
  MaterialityAssessment,
  MetricChart,
  MetricsDisclosureRequirements,
  Onboarding,
  SustainabilityAssessmentList,
} from './pieces';
import { StandardMetricsDataCollection } from './pieces/DataCollection/StandardMetricsDataCollection';
import { ESRSAssessmentSettings } from './Settings';
import { CreateReport } from './pieces/Report/CreateReport';
import { DoubleMaterialityAssessment } from './pieces/MaterialityAssessment/DoubleMaterialityAssessment/DoubleMaterialityAssessment';
import { StandardPage } from './pieces/DisclosureRequirements/StandardPage/StandardPage';
import { DisclosureRequirementPage } from './pieces/DisclosureRequirements/Metrics/DisclosureRequirementPage';
import { StandardConfigPage } from './pieces/DataCollection/StandardConfigPage';
import { DrMateriality } from './pieces/MaterialityAssessment/DoubleMaterialityAssessment/DrMateriality/DrMateriality';

export const EsrsAssessments = () => {
  return (
    <Routes>
      <Route index element={<SustainabilityAssessmentList />} errorElement={<ErrorElement />} />
      <Route
        path={`:framework/:esrsAssessmentId/onboarding`}
        element={<Onboarding />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/onboarding/standard/:standardRef`}
        element={<Onboarding />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/onboarding/data-collection/:standardRef`}
        element={<StandardConfigPage isOnboarding />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/onboarding/data-collection/:standardRef/disclosure-requirement/:disclosureRequirementRef`}
        element={<StandardMetricsDataCollection />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/onboarding/materiality/standard/:standardRef`}
        element={<DoubleMaterialityAssessment onboarding />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/onboarding/materiality/standard/:standardRef/disclosure-requirement/:disclosureRequirementRef`}
        element={<DrMateriality />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/report`}
        element={<CreateReport />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/settings`}
        element={<ESRSAssessmentSettings />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/settings/materiality`}
        element={<MaterialityAssessment />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/settings/materiality/standard/:standardRef`}
        element={<DoubleMaterialityAssessment />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/settings/materiality/standard/:standardRef/disclosure-requirement/:disclosureRequirementRef`}
        element={<DrMateriality />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/settings/data-collection/:standardRef`}
        element={<StandardConfigPage />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/settings/data-collection/:standardRef/disclosure-requirement/:disclosureRequirementRef`}
        element={<StandardMetricsDataCollection />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/:childAssessmentId?`}
        element={<EsrsAssessment />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/:childAssessmentId/standard/:standardRef/disclosure-requirement/:disclosureRequirementGroupRef?`}
        element={<EsrsAssessment />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/standard/:standardRef`}
        element={<StandardPage />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/standard/:standardRef/disclosure-requirement/metric/:disclosureRequirementRef/chart/:metricRef/:materialStandardId/:reportingUnitId?`}
        element={<MetricChart />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/standard/:standardRef/disclosure-requirement/:drType/:disclosureRequirementRef/:view?`}
        element={<DisclosureRequirementPage />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/bu-standard/:standardRef/bu/:reportingUnitId`}
        element={<StandardPage />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/bu-standard/:standardRef/bu/:reportingUnitId/disclosure-requirement/:disclosureRequirementRef/:view?`}
        element={<MetricsDisclosureRequirements />}
        errorElement={<ErrorElement />}
      />
      <Route
        path={`:framework/:esrsAssessmentId/standard/:standardRef/disclosure-requirement/:drType/:disclosureRequirementRef/target-form`}
        element={<AddTarget />}
        errorElement={<ErrorElement />}
      >
        <Route
          path=":targetId/edit"
          element={<AddTarget />}
          errorElement={<ErrorElement />}
        ></Route>
      </Route>
      <Route
        path={`:framework/:esrsAssessmentId/standard/:standardRef/disclosure-requirement/:drType/:disclosureRequirementRef/action-form`}
        element={<AddActionPage />}
        errorElement={<ErrorElement />}
      >
        <Route
          path=":actionId/edit"
          element={<AddActionPage />}
          errorElement={<ErrorElement />}
        ></Route>
      </Route>
      <Route
        path={`:framework/:esrsAssessmentId/config`}
        element={<EsrsAssessmentConfig />}
        errorElement={<ErrorElement />}
      />
    </Routes>
  );
};
